import type { z } from 'zod';

import { PositionSchema } from './position';

export const AhqSubmissionPositionSchema = PositionSchema.pick({
  baselineCost: true,
  billingHoursPerDay: true,
  id: true,
  name: true,
});

export type AhqSubmissionPosition = z.infer<typeof AhqSubmissionPositionSchema>;
